/**
 * ADR-0013 — Revenue Owner (Finance).
 *
 * Geschäftsregel: Wie Umsatz aus Verkäufen summiert wird — genau einmal.
 * Periodenfilter passiert der Aufrufer (eine Zeitdimension pro View).
 * Vollständig stornierte Verkäufe zählen nicht; Teil-Storno nutzt aktuelle Totals.
 */

import { getSaleTotalAmount } from '../restaurant/restaurantDishSaleService';
import { isSaleFullyCancelled } from '../sales/storno/saleVoidPlanning';

/**
 * @param {Array} sales
 * @returns {number}
 */
export function sumRevenue(sales = []) {
  if (!Array.isArray(sales) || sales.length === 0) return 0;
  return sales.reduce((sum, sale) => {
    if (isSaleFullyCancelled(sale)) return sum;
    return sum + getSaleTotalAmount(sale);
  }, 0);
}

/**
 * @param {Array} sales
 * @returns {{ totalRevenue: number, salesCount: number, averageOrderValue: number }}
 */
export function summarizeRevenue(sales = []) {
  const list = (Array.isArray(sales) ? sales : []).filter((s) => !isSaleFullyCancelled(s));
  const totalRevenue = sumRevenue(list);
  const salesCount = list.length;
  const averageOrderValue = salesCount > 0 ? totalRevenue / salesCount : 0;
  return { totalRevenue, salesCount, averageOrderValue };
}
